export enum FontHierarchy {
  Primary = 'Primary',
  Secondary = 'Secondary'
}
